import { Form } from '~/shared/api'
import { requiredRule } from '~/shared/utils/validation'

export default class AccountVacancyWhatWeOfferForm extends Form {
  'career_direction_ids': number[] | null = null
  'internship_expectation_ids': number[] | null = null
  'internship_priority_ids': number[] | null = null

  toInputData() {
    return {
      career_direction_ids: this.career_direction_ids,
      internship_expectation_ids: this.internship_expectation_ids,
      internship_priority_ids: this.internship_priority_ids
    }
  }

  static rules() {
    return {
      career_direction_ids: requiredRule,
      internship_expectation_ids: requiredRule,
      internship_priority_ids: requiredRule
    }
  }
}
